module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-310x310-e8518ee095019a7bd50f03fa40b92952.png";